import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import {OrganizationsService} from '../../../../core/services/organizations.service';
import {EventService} from '../../../../core/services/event.service';
import {FuseConfigService} from '../../../../core/services/config.service';

@Component({
    selector: 'app-personnel',
    templateUrl: './personnel.component.html',
    styleUrls: ['./personnel.component.scss'],
    standalone: false
})
export class PersonnelComponent implements OnInit {
  public filterData: any = {};
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild('sidenav') sidenav: MatSidenav;

  userFilters = false;
  dataSource;
  displayedColumns: string[] = ['date', 'name', 'preparation', 'execution', 'followUp', 'total'];
  currency = 'CHF';
  isOrganizer = false;
  total = 0;
  showMsg = true;
  noData = false;
  constructor(private organizationService: OrganizationsService, private eventService: EventService,
              private fuseConfig: FuseConfigService) { }

  ngOnInit() {
    this.eventService.setToAll();
    this.getCountries();
    this.fuseConfig.role.subscribe(res => {
      if (res && res === 'organisationAdmin') {
        this.isOrganizer = true;
        setTimeout(() => {
          this.sidenav.opened = false;
          this.sidenav.close();
        } , 500);
      }
    });
  }

  getCountries () {
    this.organizationService.getCountry().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.countries = res;
      } else if (res.length === 1) {
        this.getCantons(res[ 0 ].id);
        delete this.filterData.countries;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getCantons (id) {
    this.organizationService.getCity(id).subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.cantonFB = res;
      } else if (res.length === 1) {
        this.eventService.setCities({selected: true , canton: res[ 0 ].id});
        this.getOrganizations();
        delete this.filterData.cantonFB;
      } else {
        delete this.filterData.cantonFB;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  getOrganizations () {
    this.eventService.getOrganizationByCantons().subscribe((res: any) => {
      if (res.length > 1) {
        this.filterData.organizationsFB = res;
      } else if (res.length === 1) {
        this.eventService.setOrganizations(res[ 0 ].id);
        this.getTimes(res[ 0 ].id);
        delete this.filterData.organizationsFB;
      } else {
        delete this.filterData.organizationsFB;
      }
      this.filterData = JSON.parse(JSON.stringify(this.filterData));
    });
  }

  chooseFilters (e) {
    // console.log(e);
    if (e.choose === 'all') {
      this.fuseConfig.setActiveFilter(false);
      delete this.filterData.cantonFB;
      delete this.filterData.countries;
      delete this.filterData.organizationsFB;
      this.eventService.setToAll();
      this.getCountries();
    } else if (e.choose.hasOwnProperty('country')) {
      delete this.filterData.cantonFB;
      delete this.filterData.organizationsFB;
      this.getCantons(e.choose.country);
      this.eventService.setCountryId(e.choose.country);
      this.fuseConfig.setActiveFilter(true);
    } else if (e.choose.hasOwnProperty('cantonFB')) {
      delete this.filterData.organizationsFB;
      this.eventService.setCity(e.choose.cantonFB);
      this.getOrganizations();
      this.fuseConfig.setActiveFilter(true);
    } else if (e.choose.hasOwnProperty('organizationsFB')) {
      this.eventService.setOrganization(e.choose.organizationsFB);
      this.getTimes();
      this.fuseConfig.setActiveFilter(true);
    }
    // this.setDataFromFilter(e);
  }

  getTimes(id?) {
    this.eventService.getEventsTimes(id).subscribe((res: any) => {
      if (res && res.length) {
        this.showMsg = true;
        this.dataSource = res;
        this.dataSource = res.map(el => {
          let _totalRates = 0;
          let _totalHours = 0;
          if (el.events) {
            this.showMsg = false;
            el.events.map((event: any) => {
              // _totalRates = _totalRates +
              //   (+event.followUp * (+el['follow-up'] ? +el['follow-up'] : +el.rate)) +
              //   (+event.execution * (+el.execution ? +el.execution : +el.rate)) +
              //   (+event.preparation * (+el.preparation ? +el.preparation : +el.rate));
              _totalRates = _totalRates +
                (+event.followUp * (+el.preparation ? +el.preparation : +el.rate)) +
                (+event.execution * (+el.preparation ? +el.preparation : +el.rate)) +
                (+event.preparation * (+el.preparation ? +el.preparation : +el.rate));
              _totalHours = +_totalHours + +event.followUp + +event.execution + +event.preparation;
              return event;
            });
            el.totalHours = _totalHours;
            el.totalRates = _totalRates;
          }
          return el;
        });
      }
      this.noData = true;
    });
  }

}
